<app-uni-page [parent]="this" pageTitle="Utilities - Enable Account Inventory" [bodyTemplate]="bodyTemplate"
  [footerTemplate]="footerTemplate" />

<ng-template #bodyTemplate>
  <div class="flex flex-col h-full min-h-0" *ngIf="isPageReady">

    <!-- Account picker -->
    <div class="qb-list-actions flex items-center gap-3">
      <span class="text-sm font-semibold">Account</span>
      <p-select
        [options]="accounts"
        [(ngModel)]="selectedAccount"
        optionLabel="accountName"
        dataKey="id"
        [filter]="true"
        filterBy="accountName"
        placeholder="Select an account that manages its own inventory"
        appendTo="body"
        [style]="{ minWidth: '340px' }"
        (onChange)="onAccountChanged()"
      ></p-select>

      <button pButton type="button" class="p-button-raised p-button-sm" icon="pi pi-check" [disabled]="!canApply"
        (click)="apply()">
        <span>{{ submitting ? 'Please wait...' : 'Apply To Selected Orders' }}</span>
      </button>

      <span *ngIf="isLoading" class="text-sm flex items-center gap-2">
        <i class="pi pi-spin pi-spinner"></i>
        The system looks for the open job orders.
      </span>

      <span *ngIf="errorMessage" class="text-sm font-semibold" style="color: var(--p-red-500, #ef4444)">
        {{ errorMessage }}
      </span>
    </div>

    <ng-container *ngIf="hasRun && joHeaders.length > 0">

      <!-- Account-level settings. Written onto every order ticked below. -->
      <div class="mx-4 mb-2 qb-detail-card qb-primary-tint px-4 py-3 shrink-0">
        <div class="flex flex-wrap items-center gap-x-6 gap-y-2">
          <span class="text-xs uppercase tracking-wide font-semibold whitespace-nowrap">
            Account Settings
          </span>

          <div class="flex items-center gap-2 grow" style="min-width: 360px">
            <span class="text-xs uppercase tracking-wide whitespace-nowrap"
              style="color: var(--p-text-muted-color)">Inventory Program</span>
            <div class="grow">
              <p-select
                [options]="programNames"
                [(ngModel)]="selectedProgramName"
                [editable]="true"
                placeholder="Select or type the inventory program name"
                appendTo="body"
                styleClass="w-full"
                (onChange)="onProgramNameChanged()"
              ></p-select>
            </div>
          </div>

          <div class="flex items-center gap-2 whitespace-nowrap">
            <p-checkbox [(ngModel)]="chargeAddonsOnReissuance" [binary]="true"
              inputId="chargeAddons"></p-checkbox>
            <label for="chargeAddons" class="text-sm">Charge addons on reissuance</label>
          </div>

          <div class="text-sm whitespace-nowrap" style="color: var(--p-text-muted-color)">
            {{ checkedCt }} order(s) selected
          </div>
        </div>

        <div class="text-xs mt-2" style="color: var(--p-text-muted-color)">
          The system writes these settings, and the prices below, onto every job order you select. Use the same
          inventory program name as the account's inventory orders.
        </div>
      </div>

      <p-splitter class="w-full grow min-h-0" layout="vertical" styleClass="h-full" [panelSizes]="[55, 45]">
        <!-- Step 1: pick the orders -->
        <ng-template pTemplate>
          <div class="flex h-full w-full flex-col overflow-hidden">
            <div class="qb-child-actions shrink-0 flex items-center gap-3">
              <span class="text-sm font-semibold">1. Select the job orders to change</span>
              <span class="text-xs" style="color: var(--p-text-muted-color)">
                A green row can already use the account's inventory.
              </span>
            </div>
            <app-ag-grid [gridOptions]="johGridOptions" [rowData]="joHeaders" class="min-h-0 flex-1"></app-ag-grid>
          </div>
        </ng-template>

        <!-- Step 2: price only the styles those orders contain -->
        <ng-template pTemplate>
          <div class="flex h-full w-full flex-col overflow-hidden">
            <div class="qb-child-actions shrink-0 flex items-center gap-3">
              <span class="text-sm font-semibold">2. Reissuance price for one unit, by style</span>
              <span class="text-xs" style="color: var(--p-text-muted-color)">
                <ng-container *ngIf="isLoadingDetails">
                  <i class="pi pi-spin pi-spinner"></i>
                  The system reads the order lines.
                </ng-container>
                <ng-container *ngIf="!isLoadingDetails && rows.length > 0">
                  {{ inProgramCount }} of {{ rows.length }} styles in program. Leave New Reissue Amt empty to keep
                  the amount that is there now.
                </ng-container>
                <ng-container *ngIf="!isLoadingDetails && rows.length === 0">
                  Select job orders above to list the styles they contain.
                </ng-container>
              </span>
            </div>
            <app-ag-grid [gridOptions]="styleGridOptions" [rowData]="rows" class="min-h-0 flex-1"></app-ag-grid>
          </div>
        </ng-template>
      </p-splitter>
    </ng-container>

    <div *ngIf="hasRun && joHeaders.length === 0" class="p-4 text-sm">
      This account has no open job orders.
    </div>
  </div>
</ng-template>

<ng-template #footerTemplate>
  <div class="left-buttons">
    <button pButton type="button" class="p-button-raised" (click)="goBack()"><span>Go Back</span></button>
  </div>
</ng-template>
